/*
  Force-limit Instafeed app blocks to a specific number of tiles.
  - Works even when the app re-renders items asynchronously
  - Hooks into DOMContentLoaded, load, and shopify:section:load
*/
(function () {
  var MAX_ITEMS = 8;
  var WRAPPER_SELECTOR = '.instafeed-new-layout-wrapper';
  var ITEM_SELECTOR = '.instafeed-new-layout-item';
  var observedWrappers = new WeakSet();

  function enforceCountInWrapper(wrapper) {
    try {
      if (!wrapper) return;
      var items = Array.prototype.slice.call(wrapper.querySelectorAll(ITEM_SELECTOR));
      if (items.length > MAX_ITEMS) {
        for (var i = MAX_ITEMS; i < items.length; i++) {
          items[i].parentNode && items[i].parentNode.removeChild(items[i]);
        }
      }
    } catch (e) {
      // swallow to avoid blocking theme scripts
    }
  }

  function enforceCountAll() {
    var wrappers = document.querySelectorAll(WRAPPER_SELECTOR);
    if (!wrappers || !wrappers.length) return;
    wrappers.forEach(enforceCountInWrapper);
  }

  function watchWrapper(wrapper) {
    if (!wrapper || observedWrappers.has(wrapper)) return;
    observedWrappers.add(wrapper);
    var mo = new MutationObserver(function () {
      enforceCountInWrapper(wrapper);
    });
    mo.observe(wrapper, { childList: true, subtree: true });
  }

  function attachObservers() {
    // Observe existing wrappers
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(function (w) {
      watchWrapper(w);
    });

    // Observe for wrappers added later
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches(WRAPPER_SELECTOR)) {
            watchWrapper(node);
            enforceCountInWrapper(node);
          } else if (node.querySelector) {
            var found = node.querySelectorAll(WRAPPER_SELECTOR);
            if (found && found.length) {
              found.forEach(function (w) {
                watchWrapper(w);
                enforceCountInWrapper(w);
              });
            }
          }
        });
      });
    });
    bodyObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }

  function boot() {
    enforceCountAll();
    attachObservers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', enforceCountAll);
  document.addEventListener('shopify:section:load', function () {
    // Delay slightly to allow app blocks to finish rendering
    setTimeout(function () {
      enforceCountAll();
      attachObservers();
    }, 200);
  });
})();


